import _ from './header.module.scss'
import React, {useEffect, useRef} from 'react'
import {useSharedStore} from '../state/shared-store-context'
import {$, $$$} from '../shared/class-name'
import {startAutoScroll, stopAutoScroll} from '../shared/auto-scroll'
import {useHideAwarePosition} from '../hooks/use-hide-aware-position'
import {HeaderNotifications} from '../apps/outof195/components/notifications/header-notifications'
import {useLocation} from 'react-router-dom'
import {useMobileFirst} from '../hooks/use-mobile-first'
import {useIsMobile} from '../hooks/use-is-mobile'

export const Header = ({children}) => {
    const { sharedState, actions } = useSharedStore()
    const leftContainerRef = useRef(null)
    const rightContainerRef = useRef(null)
    const contentRef = useRef(null)
    const rootRef = useRef(null)
    const {pathname} = useLocation()
    const mobileFirst = useMobileFirst()
    const isMobile = useIsMobile()

    useEffect(() => {
        if (sharedState.autoscroll) startAutoScroll(80, actions.stopAutoscroll)
        else stopAutoScroll()
    }, [sharedState.autoscroll])

    const hasHeaderContent = sharedState.headerContent != null || sharedState.headerLeftContainerContent != null
    const preHidden = (!hasHeaderContent || sharedState.scrolledPast320) && !sharedState.noHideHeader
    const {position, hidden, noTransition, content, backdropFilterEnabled
    } = useHideAwarePosition(sharedState.floatingHeaderPosition, preHidden, sharedState.headerContent)

    return <><div ref={rootRef} className={$$$(
        $(_.root),
        $(_.mobileFirst, mobileFirst),
        $(_.hidden, hidden),
        $(_.noTransition, noTransition),
        $(_.titleMode, sharedState.isTitleScrolling),
        $(_.floating, sharedState.floatingHeader),
        $(_.left, position === 'left'),
        $(_.right, position === 'right'),
        $(_[`_${sharedState.headerColumnCount || 5}columns`]),
        $(_.profile, sharedState.headerProfile),
        $(_.centered, pathname.startsWith('/auth')),
        $(_.backdropFilterEnabled, backdropFilterEnabled),
        $(_.transparent, sharedState.transparentToolbars),
    )} data-layout="header"><div
        className={_.content}
        ref={contentRef}
    ><div className={_.innerContent}>
        <div className={$$$($(_.menuContainer))}>
            {content}
        </div>
        {children}
        {!isMobile && sharedState.headerLeftContainerContent && <div className={_.leftContainer} ref={leftContainerRef}>
            {sharedState.headerLeftContainerContent({leftContainerRef, contentRef})}
        </div>}
        <div className={_.rightContainer} ref={rightContainerRef}>
            {sharedState.headerRightContainerContent?.({rightContainerRef, contentRef})}
        </div>
    </div></div></div>
        <HeaderNotifications rootElementRef={rootRef}/>
    </>
}
